
// frontend/src/pages/home/Services.jsx

import React from 'react';

const services = [
  {
    title: 'Software Development',
    img: '/software_development.png',
    text: 'Web, mobile and cloud-based application development designed around clear business needs.',
  },
  {
    title: 'Product Delivery',
    img: '/product_delivery.png',
    text: 'Engineering-led support for MVPs, digital platforms, enhancements and product rollouts.',
  },

  {
    title: 'Technical Support',
    img: '/technical_support.png',
    text: 'Ongoing maintenance, improvements and operational support for delivered systems.',
  },

  {
    title: 'AI and Automation',
    img: '/ai_automation.png',
    text: 'AI, automation and data-driven workflows focused on operational value.',
  },
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="section-heading">
        <p className="eyebrow">What We Do</p>
        <h2>Reliable technology delivery</h2>
        <p>
          We help organisations build, improve and support digital platforms with a clear focus
          on engineering quality, execution and business value.
        </p>
      </div>

      <div className="cards">
        {services.map((service) => (
          <article className="card" key={service.title}>
            <img src={service.img} alt={service.title} className="card-img" />
            <div className="accent" />
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

